import { createAction } from 'redux-actions';

export const deleteTransactionFolderAction = createAction('DELETE_TRANSACTION_FOLDER');

export const moveTransactionDocumentAction = createAction('MOVE_TRANSACTION_DOCUMENT');

export const editTransactionFolderAction = createAction('EDIT_TRANSACTION_FOLDER');
